import { ValidationResult, Validator } from '../form-validation'
import { dateValidator } from './date-validator'

export const childDateValidator = (value: any[] | null) : ValidationResult => {  
    let valid = true

    if (value) {
        valid = !value.some((children) => !dateValidator(children.birthDate).valid)
    }

    return {
        valid: valid
    }
}
